<template>
  <div class="alert alert-danger" v-if="form.errors.any()">
    <button v-if="dismissible" type="button" class="close" aria-label="Close" @click="dismiss">
      <span aria-hidden="true">&times;</span>
    </button>

    <div v-if="message" v-html="message"></div>

    <ul>
      <li v-for="error in form.errors.flatten()" v-html="error"></li>
    </ul>
  </div>
</template>

<script>
import Alert from './Alert'

export default {
  extends: Alert,

  name: 'alert-errors',

  props: {
    message: {
      type: String,
      default: 'There were some problems with your input.'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Errors.vue?0bc042ea